import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { SocketService } from './services/Socket.service';

@Injectable({ providedIn: 'root' })
export class AuthdataMessageService {
    private subject = new Subject<any>();
    private accountStatus = new Subject<any>();
    private profilepic = new Subject<any>();

    private unreadCountSubject = new BehaviorSubject<any>(null);
    unreadCount$ = this.unreadCountSubject.asObservable();

    constructor(
        private socketService: SocketService,
        private ngZone: NgZone,
    ) {

        this.listenToSocket();
    }

    listenToSocket() {
        this.socketService.listenUnread('unread_message_counters')
            .subscribe((message: any) => {
                console.log('message in service:', message)
                if (message) {
                    // ensure Angular detects the change
                    this.ngZone.run(() => {
                        this.unreadCountSubject.next(message?.unread_message_counters);
                        const authUser = JSON.parse(localStorage.getItem('authUser') || '{}');
                        authUser.unread_message_counters = message;
                        localStorage.setItem('authUser', JSON.stringify(authUser));
                    });
                }
        });
    }

    sendAccoutStatus(auth_data: any) {
        this.accountStatus.next(auth_data);
    }

    clearAccoutStatus() {
        this.accountStatus.next(true);
    }

    getAccoutStatus(): Observable<any> {
        return this.accountStatus.asObservable();
    }

    sendAuthUserDataMessage(messageData: any) {
        this.subject.next(messageData);
    }

    clearAuthUserDataMessage() {
        this.subject.next(true);
    }

    getAuthUserDataMessage(): Observable<any> {
        return this.subject.asObservable();
    }

    sendProfilePicMessage(messageData: any) {
        this.profilepic.next(messageData);
    }

    clearProfilePicMessage() {
        this.profilepic.next(true);
    }

    getProfilePicMessage(): Observable<any> {
        return this.profilepic.asObservable();
    }
}
